import bookingStyles from './styles.module.scss'

export const AdditionalBenefits = ({ images, label }) => (
    <div className={bookingStyles.additionalBenefitsWrap}>
        {label && <p className={bookingStyles.benefitsLabel}>{label}</p>}
        <ul className={bookingStyles.additionalBenefitsList}>
            {images.map((item, index) => (
                <li key={index} className={bookingStyles.additionalBenefitsListItem}>
                    <img
                        src={item.url}
                        alt={item.description || item.name}
                        className={bookingStyles.additionalBenefitsIcon}
                    />
                    <span>{item.description || item.name}</span>
                </li>
            ))}
        </ul>
    </div>
)
